// client/src/utils/snsAccountCache.js

// 사용자별 캐시 저장소
const userCaches = new Map();
const CACHE_TTL = 5 * 60 * 1000; // 5분

// 현재 로그인한 사용자 ID 가져오기
function getCurrentUserId() {
  return window.__ME__?.id || 'anonymous';
}

// 사용자별 캐시 가져오기
function getUserCache(userId) {
  if (!userCaches.has(userId)) {
    userCaches.set(userId, {
      data: null,
      promise: null,
      lastFetchTime: 0
    });
  }
  return userCaches.get(userId);
}

// SNS 계정 정보 가져오기 (캐시 우선)
export async function getSNSAccounts(force = false) {
  const userId = getCurrentUserId();
  const cache = getUserCache(userId);
  
  // 캐시가 유효하면 즉시 반환
  if (!force && cache.data && (Date.now() - cache.lastFetchTime) < CACHE_TTL) {
    return cache.data;
  }

  // 이미 fetch 중이면 같은 Promise 반환 (중복 방지)
  if (cache.promise) {
    return cache.promise;
  }

  cache.promise = (async () => {
    try {
      const res = await fetch('/api/influencer/mybiz/sns-list', { credentials: 'include' });
      const data = await res.json();

      if (res.ok && data.ok) {
        cache.data = {
          groups: data.groups || { instagram: [], blog: [], youtube: [], tiktok: [] },
          total: data.total || 0
        };
        cache.lastFetchTime = Date.now();
        return cache.data;
      } else {
        throw new Error('Failed to fetch SNS accounts');
      }
    } catch (err) {
      console.error('SNS 계정 로딩 실패:', err);
      throw err;
    } finally {
      cache.promise = null;
    }
  })();

  return cache.promise;
}

// 캐시 초기화 (특정 사용자 또는 전체)
export function clearSNSCache(userId = null) {
  if (userId) {
    // 특정 사용자만 초기화
    userCaches.delete(userId);
  } else {
    // 현재 사용자 초기화
    const currentUserId = getCurrentUserId();
    userCaches.delete(currentUserId);
  }
}

// 모든 사용자 캐시 초기화 (로그아웃 시 사용)
export function clearAllSNSCache() {
  userCaches.clear();
}

// 캐시된 데이터 즉시 읽기 (없으면 null)
export function readSNSCache() {
  const userId = getCurrentUserId();
  const cache = getUserCache(userId);
  
  if (cache.data && (Date.now() - cache.lastFetchTime) < CACHE_TTL) {
    return cache.data;
  }
  return null;
}

// 백그라운드에서 미리 로딩 (결과 무시)
export function warmSNSCache() {
  getSNSAccounts().catch(() => {});
}